import { apiUrl } from '../services/env';
import request from '../services/request';
import storage from '../services/storage';

export const trackVisit = data => {
  if (
    data.referrer.indexOf('checkoutpage') > -1 ||
    data.referrer.indexOf('checkoutpage.dev') > -1
  ) {
    return false;
  }

  const visits = Number(storage.local.getItem(`${data.pageId}-visits`));
  storage.local.setItem(`${data.pageId}-visits`, visits + 1);

  return request(`${apiUrl}/visits`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });
};
